
import UI from "./components/UI";
import { useDispatch } from 'react-redux'
import { setUser } from "./store/slice/userSlice";
import { useEffect, useState } from 'react'
import { check } from './http/usersAPI'



/////
let trackerPromise = null;

function loadIMTracker() {
  if (trackerPromise) {
    return trackerPromise;
  }

  trackerPromise = new Promise((resolve, reject) => {
    if (window.IM?.Tracker) {
      resolve(window.IM.Tracker);
      return;
    }

    const script = document.createElement('script');

    script.async = true;
    script.src =
      'https://merchant.intellectmoney.ru/im.tracker.js?organizationId=75417';

    script.onload = () => {
      console.log('SCRIPT LOADED');
      console.log('window.IM:', window.IM);
      console.log('typeof IM:', typeof IM);

      if (window.IM?.Tracker) {
        resolve(window.IM.Tracker);
      } else {
        reject(new Error('IM Tracker не найден после загрузки скрипта'));
      }
    };

    script.onerror = () => {
      reject(new Error('Не удалось загрузить IM Tracker'));
    };

    document.head.appendChild(script);
  });

  return trackerPromise;
}

async function initTracker() {
  try {
    const Tracker = await loadIMTracker();

    Tracker.setUserID('test@test.com');

    console.log('Tracker initialized');
  } catch (error) {
    console.error('IM Tracker error:', error);
  }
}

//const Tracker = await loadIMTracker();

//Tracker.setUserID("test@test.com");
/*
Tracker.forceFlushWithCallback(
        function() {
            console.log( 'valid' )
        },
        function() {
            console.log( 'notvalid' )
        }
    );
*/





//////

const App = () => {
  const dispatch = useDispatch()
  const [isAuthChecking, setIsAuthChecking] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      initTracker();
    }, 1000);
  
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    check()
      .then(data => {
        if (data) {
          dispatch(setUser(data))
        }
      })
      .finally(() => {
        setIsAuthChecking(false)
      })
  }, [dispatch])

  if (isAuthChecking) {
    return null
  }

  return (
    <>
      <UI />
    </>
  );


}

export default App;
